






























































import { Component, Prop, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import { ITaxBusinessType } from "@/models/tax";
import { IState } from "@/store";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState({
      taxBusinessTypes: (state: IState) => state.constants.taxBusinessTypes
    })
  }
})
export default class TaxBusinessTypesTable extends Mixins(Context) {
  // Props
  @Prop({ default: false })
  public readonly isCheckable!: boolean;

  @Prop({ default: () => [] })
  public readonly checkedBusinessTypes!: ITaxBusinessType[];

  // Data
  public taxBusinessTypes!: ITaxBusinessType[];
  public isLoading = false;
  public currentPage = 1;
  public limit = 10;
  public isReloading = false;
  public requestError = false;

  // Lifecycle methods
  public async created() {
    this.loadData();
  }

  // Getters
  public get pageData() {
    const current = this.currentPage - 1;
    const start = current * this.limit;
    return this.$_.slice(this.taxBusinessTypes, start, start + this.limit);
  }

  public get checkedIds() {
    return this.checkedBusinessTypes.map(i => i.id);
  }

  // Methods
  public async loadData() {
    try {
      this.isLoading = true;
      await this.$store.dispatch("constants/getTaxBusinessTypes");
    } catch (error) {
      this.requestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public onCheck({ isChecked, taxBusinessType }) {
    if (
      isChecked &&
      !this.checkedBusinessTypes.find(i => i.id === taxBusinessType.id)
    ) {
      this.checkedBusinessTypes.push(taxBusinessType);
    }
    if (
      !isChecked &&
      this.checkedBusinessTypes.find(i => i.id === taxBusinessType.id)
    ) {
      this.$emit(
        "update:checkedBusinessTypes",
        this.checkedBusinessTypes.filter(i => i.id !== taxBusinessType.id)
      );
    }
  }

  // Override mixin method
  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(params, {
      params: {
        ...params.filter
      }
    });
  }

  public storeGetData(): Promise<any> {
    return this.$store.dispatch("constants/getTaxBusinessTypes");
  }
}
